/* eslint-disable no-nested-ternary */
import { ChangePasswordPageState } from '../../../../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';
import { applyRule } from './applyRule';

export const validateRules = (value: string) => {
  const valueLenght = value.length;
  const lowerCase = applyRule(value, /[a-z]/g, true);
  const upperCase = applyRule(value, /[A-Z]/g, true);
  const number = applyRule(value, /[0-9]/g, true);
  const specialChar = applyRule(value, /[a-zA-Z0-9]/g, false);
  const counter = lowerCase + upperCase + number + specialChar;

  const strength = (valueLenght >= 14 && counter >= 3) ? 'VeryStrong' : (valueLenght >= 11 && counter >= 3) ? 'Strong' : 'Weak';
  const rules: ChangePasswordPageState = {
    // Regle 8 caracteres minimum
    Regle8CharMin: (valueLenght >= 8),
    // Regle 1 minuscule
    RegleLettreMinuscules: (lowerCase === 1),
    // Regle 1 majuscule
    RegleLettreMajuscules: (upperCase === 1),
    // Regle 1 chiffre
    RegleChiffre: (number === 1),
    // Regle 1 caractere special
    RegleCharSpec: (specialChar === 1),
    // Regle 1 caractere special
    Regle3Element: (counter >= 3),
    // Password strenght
    PasswordStrength: `PasswordStrength${strength}`,
    PasswordStrengthClass: `PasswordStrenghClass${strength}`,
    ErrorMessageText: [],
  };

  return rules;
};
